import { apiClient } from '../client';

export interface PartnerAccountAdminView {
  id: number; email: string; full_name: string; organization_name: string; phone: string | null;
  status: string; email_verified_at: string | null; approved_by_name?: string; created_at: string; last_login_at: string | null; rejected_reason: string | null;
}

export const partnerAccountsAdminApi = {
  listPending: () => apiClient.get<{ data: PartnerAccountAdminView[] }>('/api/admin/partner-accounts/pending'),
  listAll: () => apiClient.get<{ data: PartnerAccountAdminView[] }>('/api/admin/partner-accounts'),
  approve: (id: number) => apiClient.post<{ data: { id: number; status: string } }>(`/api/admin/partner-accounts/${id}/approve`),
  reject: (id: number, reason: string) => apiClient.post<{ data: { id: number; status: string } }>(`/api/admin/partner-accounts/${id}/reject`, { reason }),
  suspend: (id: number) => apiClient.post<{ data: { id: number; status: string } }>(`/api/admin/partner-accounts/${id}/suspend`),
};
